import { useUser } from './index';

const useUserAdmin = (): boolean => {
   const [user] = useUser();
   return user?.email?.endsWith('@titl.app') || false;
};
export default useUserAdmin;
